export const flatten = (object) => {
  let o = Object.assign(
    {},
    ...(function _flatten(objectBit, path = '') {
      //spread the result into our return object
      return [].concat(
        //concat everything into one level
        ...Object.keys(objectBit).map(
          //iterate over object
          (key) =>
            objectBit[key] &&
            typeof objectBit[key] === 'object' &&
            !(objectBit[key] instanceof Date) //check if there is a nested object
              ? _flatten(
                  objectBit[key],
                  Array.isArray(objectBit) ? `${path}[${key}]` : `${path}.${key}`,
                ) //call itself if there is
              : {
                  [Array.isArray(objectBit) ? `${path}[${key}]` : `${path}.${key}`]: objectBit[key],
                }, //append object with it’s path as key
        ),
      );
    })(object),
  );
  return Object.assign(
    {},
    ...(function _sliceFirst(obj) {
      return [].concat(...Object.keys(o).map((key) => ({ [key.slice(1)]: o[key] }))); // slicing the first dot
    })(o),
  );
};
